import { Controller } from "@hotwired/stimulus"

import { basicSetup, EditorView } from "codemirror"
import { vsCodeDark } from "@fsegurai/codemirror-theme-vscode-dark";
import { keymap } from "@codemirror/view"
import { EditorState, Compartment } from "@codemirror/state"
import { html } from "@codemirror/lang-html"
import { css } from "@codemirror/lang-css"
import { indentWithTab } from "@codemirror/commands"
import { autocompletion } from "@codemirror/autocomplete"
import { pdfCompletionSource } from "./codemirror/pdf_completion"
import { imageCompletionSource } from "./codemirror/image_completion"
import { articleCompletionSource } from "./codemirror/article_completion"
import { moduleCompletionSource } from "./codemirror/module_completion"
import { matcherCompletionSource } from "./codemirror/matcher_completion"
import { menuCompletionSource } from "./codemirror/menu_completion"
import { layoutCompletionSource } from "./codemirror/layout_completion"
import { formCompletionSource } from "./codemirror/form_completion"

export default class extends Controller {
  static values = {
    language: { type: String, default: "html" },
  }

  connect() {
    this.createEditor()
    document.addEventListener("turbo:before-cache", this.teardown)
  }

  disconnect() {
    this.teardown()
  }

  createEditor() {
    let tabSize = new Compartment
    const extensions = [
      basicSetup,
      vsCodeDark,
      this.languageExtension(),
      keymap.of([indentWithTab]),
      tabSize.of(EditorState.tabSize.of(4)),
      autocompletion({ override: [
        matcherCompletionSource,
        articleCompletionSource,
        imageCompletionSource,
        pdfCompletionSource,
        moduleCompletionSource,
        menuCompletionSource,
        layoutCompletionSource,
        formCompletionSource
        ]
      }),
      EditorView.updateListener.of(this.onChange)
    ]
    const textarea = this.element

    this.editor = new EditorView({
      state: EditorState.create({
        doc: textarea.value,
        extensions
      })
    })

    textarea.after(this.editor.dom)
    textarea.hidden = true
  }

  teardown = () => {
    this.editor?.destroy()
    this.editor = null
  }

  onChange = update => {
    if (!update.docChanged) return

    this.element.value = update.state.doc.toString()

    // 🔑 Makes DirtyForm, Turbo, validations work
    this.element.dispatchEvent(
        new Event("input", { bubbles: true })
    )
  }

  languageExtension() {
    switch (this.languageValue) {
      case "css": return css()
      default:    return html()
    }
  }
}
